import axios from 'axios';

async function ObtenerPartner(prmPartner: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_partners"
    
    const datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!", "id_partner": prmPartner}
    
    try {
        const response = await axios.post(url, datosEnvio);
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerPartner;